export default __webpack_public_path__ + "static/media/undraw_add_file2.gvbb.22d42370.svg";